type PhoneType = 'Short Code' | 'Toll-Free' | 'Local' | 'Aircall' | 'Mobile' | 'Landline'

export const tooltipText = {
  disabledCall: (phoneType: PhoneType = 'Toll-Free') => [
    'Calling is not available on the trial ',
    <br key={'br'} />,
    `number. Switch to the ${phoneType} inbox `,
    <br key={'br'} />,
    'to try-out Salesmsg Calling.',
  ],
}
